











































import Vue from 'vue';
import Component from 'vue-class-component';
import ProfileActivity from '@/components/Profile/activity/ProfileActivity.vue';
import { ActivityModel } from '@/models/activity.model';
import { UserApi } from '@/api/user.api';
import { userModule, userState } from '@/utils/store-acessor';
import { UserModel } from '@/models/user.model';
import { shareReplay, take } from 'rxjs/operators';

@Component({
  components: { ProfileActivity }
})
export default class ProfileActivities extends Vue {
  activities: ActivityModel[] = [];
  @userModule.Getter('user') user!: UserModel;

  loading = false;

  async mounted() {
    await userState.fetchUser();
    if (this.user?.slug) {
      this.loading = true;
      new UserApi()
        .fetchActivities(this.user.slug)
        .pipe(take(1), shareReplay())
        .subscribe(
          res => {
            this.loading = false;
            this.activities = res.data;
          },
          () => (this.loading = false)
        );
    }
  }
}
